import { SectionTitle } from "@components/SectionTitle";
import { PremSettingsForm } from "./prem-settings-form";

import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { PremSettings } from "@libs/api/gateways/tg/tg-ops-gateway.dtos";
import { usePremSettingsQuery } from "@libs/api/gateways/tg/tg-ops-gateway.hooks";
import { Permissions } from "@libs/permissions/permissions.enum";
import { NoPermissionError } from "@components/errors/NoPermissionError";

interface PremSettingsPageProps {
  tenant: Tenant;
}

export const PremSettingsPage = ({ tenant }: PremSettingsPageProps) => {
  const premSettingsQuery = usePremSettingsQuery(tenant.id);
  const { data: hasPreRelease } = usePermissionsCheckQuery(
    [
      Permissions.OpsConsolePreRelease,
      Permissions.ProsSiteManagementRead,
      Permissions.ProsSiteManagementWrite
    ],
    "or"
  );

  return (
    <>
      <SectionTitle>Bp Premier Settings</SectionTitle>
      {hasPreRelease ? (
        <QueryStateIndicator<PremSettings[]>
          {...premSettingsQuery}
          loadingTitle="Loading settings from Premier ..."
        >
          {premSettings => (
            <PremSettingsForm premSettings={premSettings} siteId={tenant.id} />
          )}
        </QueryStateIndicator>
      ) : (
        <NoPermissionError />
      )}
    </>
  );
};
